module.exports = __webpack_public_path__ + "static/media/filter.c8dd6a01.svg";